import { render, staticRenderFns } from "./InventoryViewTrackingDimension.vue?vue&type=template&id=1550b38a&"
import script from "./InventoryViewTrackingDimension.vue?vue&type=script&lang=ts&"
export * from "./InventoryViewTrackingDimension.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports